import { axiosInstance } from '../../serviceConf';

export function login(correo) {
    let url = `b2b/usuarioGet`
    let params = {
      correo: correo,
     }
    return new Promise((resolve, reject) =>
      axiosInstance.get(url,{ params })
      .then((response) => {
        resolve(response.data)
        
      }).catch((err)=>{
        reject(err)
      })
    )
}
